import { AfterViewInit, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment.style';
import { INDRACompareFareModalComponent } from '@ibe.components/shared/compare-fare-modal/compare-fare-modal.indra.component';
import { BookedTrip, Flight } from '@ibe/models';
import { Brand, BookingStep } from '@ibe/models/ui';
import { BookingService } from '@ibe/services';
import { ModalService, SidebarService, ScreenService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable, fromEvent, combineLatest, Subscription } from 'rxjs';
import { takeWhile, debounceTime, distinctUntilChanged, startWith, map, tap } from 'rxjs/operators';

import * as fromStore from '../../../../store';
import * as FlightResultActions from '@ibe/store/actions/flight-result.actions';
import { FlightResultComponent } from './flight-result.component';
import { PageScrollService } from 'ngx-page-scroll-core';
import { DOCUMENT, getCurrencySymbol } from '@angular/common';
import { DailyCost } from '@ibe.models/daily-cost.model';
import { RouteTrip } from '@ibe/store/states/mini-ibe.indra.state';
import * as moment from 'moment';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAFareInformationRequest } from '@ibe.models/atc.availability.indra.model.lib';
import { INDRAFareInformationResponse, INDRAFeature } from '@ibe.models/ancillary.indra.model.lib';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import * as _ from 'lodash';
import * as MilesBarActions from '@ibe/store/actions/miles-bar.actions';
import * as FlightFareInformationActions from '@ibe/store/actions/fare-information.indra.action';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

import {
	AIRLINE_TAP_CODE,
	SESSION_VAR_KEY_CURRENCY,
	BRAND_CODE_DISCOUNT,
	BRAND_CODE_EXECUTIVE,
	BRAND_CODE_BASIC,
	BRAND_CODE_CLASSIC,
	BRAND_CODE_PLUS,
	BRAND_CODE_TOP_EXECUTIVE,
	TAP_COMMERCIAL_BUSINESS_CABIN_RBD_LIST,
	TAP_AWARD_BUSINESS_CABIN_RBD_LIST,
	STAR_AWARD_BUSINESS_CABIN_RBD_LIST,
	PAX_TYPE_ADULT_CODE,
	PAX_TYPE_YOUNG_ADULT_CODE,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP,
	BASIC_ANCILLARY_CODES_MEALS,
	BASIC_ANCILLARY_CODES_FASTTRACK,
	BASIC_ANCILLARY_CODES_LOUNGE,
	BUSINESS_BRANDS
} from '@ibe.config';

const MOBILE_MESSAGE_LINE_LIMIT = 22;
@Component({
	selector: 'app-flight-result',
	templateUrl: './flight-result.indra.component.html',
	styleUrls: ['./flight-result.component.scss'],
	host: {
		class: 'app-flight-result'
	},
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class INDRAFlightResultComponent extends FlightResultComponent
	implements OnInit, AfterViewInit, OnDestroy, OnChanges {
	isAlive = true;
	discountMiles$: Observable<number> = this.store.select(fromStore.getMilesBarDiscount);
	discountMiles: number;

  	@Input() isLoggedIn = false;

	// This will reset all the hidden non-collapse flights
	@Input()
	activeOpenFlightId: number;

	@Input()
	flightInfo;

	@Input()
	brandsList;

	@Input()
	showDetails: boolean = false;

	@HostBinding('class.is-open')
	isOpen: boolean = false;

	hasLowestPrice: boolean = false;
	hasLastSeats: boolean = false;

	private _toggle = false;
	lowestAdtPrice: number;
	calendarLowestPrice: number;
	matrixLowestPrice: number;
	@Input()
	set toggle(open: boolean) {
		this._toggle = open;
		if (open == false) {
			this.selected_cabin = undefined;
			this.isOpen = false;
		} else {
			this.isOpen = true;
		}
	}

	get toggle(): boolean { return this._toggle; }

	@Output()
	selectCabin = new EventEmitter<any>();

	@Output()
	clickFeature = new EventEmitter<any>();

	@Output()
	brandSelected = new EventEmitter<boolean>();

	isMobile$: Observable<boolean> = this.store.select(fromStore.isScreenMobile);
	isMobile: boolean = false;
	private resize$: Observable<number>;

	private current_step$: Observable<number> = this.store.select(fromStore.getSelectedBookingCurrentStep);
	current_step: number;

	private timeToThink$: Observable<boolean> = this.store.select(fromStore.getBookingStepsTTT);
	timeToThink: boolean = false;

	bookAwardFlight$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlight: boolean;

	booking_steps$: Observable<BookingStep[]> = this.store.select(fromStore.getSelectedBookingSteps);
	booking_steps: Array<BookingStep>;

	flightFilter$: Observable<any> = this.store.select(fromStore.getFlightsFilterState);
	flightFilter: any;

	private miles$: Observable<string> = this.store.select(fromStore.getOptionsBarPriceUnit);
	milesInfo;

	private costsPerDay$: Observable<Array<DailyCost[]>> = this.store.select(fromStore.getBookingStepsCostsPerDay);
	hasChanges$: Observable<any> = combineLatest([this.booking_steps$, this.costsPerDay$]);

	seachRoute$: Observable<Array<RouteTrip>> = this.store.select(fromStore.getMiniIBESearchRoutes);
	searchRoute;

	routeType$: Observable<any> = this.store.select(fromStore.getMiniIBERouteType);
	tripType;

	flightFareInformation$: Observable<any> = this.store.select(fromStore.getFlightFareInformation);
	flightFareInformation;

	selected_cabin = undefined;
	selected_cabinIndex = 0;
	selected_brand = undefined;
	selectedBrandName: string;

	brands: {
		economy: Array<Brand>;
		business: Array<Brand>;
	};

	currency: any;
	flight_total = '';
	complete: boolean = false;
	isCodeShare: boolean = false;
	isMixedCabinFlightTrip: boolean = false;
	isTAPCarrier: boolean = false;
	economyFlightSegmentNumbers;
	isMixed: boolean = false;

	flight: any;
	allSubs: Subscription[] = [];

	scrollToTimeout;
	starAwardsFlightMixedWithEconomy: boolean = false;
	starAwardsFlightMixedWithExecutive: boolean = false;

	ancMealLabelSegments = [];
	ancFastTrackSegments = [];
	ancLoungeSegments = [];
	longLSM = false; // Limit only to be used when mobile device detected - from TAPUX-TEAM


	constructor(
		private router: Router,
		private bookingService: BookingService,
		private store: Store<fromStore.State>,
		private sidebarService: SidebarService,
		private modalService: ModalService,
		private pageScrollService: PageScrollService,
		private screen: ScreenService,
		private dateService: INDRADateService,
		private bfmDataStorage: INDRABFMDataStorageService,
		private ancillariesService: INDRAAncillariesService,
		private bookingSearchService: INDRABookingSearchService,
		private currencyService: INDRACurrencyService,
		private cdr: ChangeDetectorRef,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		protected ibeAdminService: INDRAIbeAdminService,
		@Inject(DOCUMENT) private document: any,
	) {
		super();

		this.discountMiles$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(discountMiles => {
				this.discountMiles = discountMiles;
				this.cdr.markForCheck();
			});

		this.isMobile$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isMobile = value;
				if (value) {
					try {
						const lastPriceTranslatedText = this.ibeAdminService.getTranslationValue('availability.flightsPage.text.lastseatshurry');
						if (lastPriceTranslatedText) {
							this.longLSM = lastPriceTranslatedText.length > MOBILE_MESSAGE_LINE_LIMIT;
						}
					} catch (err) { 
						console.error('Error on translation availability.flightsPage.text.lastseatshurry', err);
					}
					
				}
			});

		this.resize$ = fromEvent(window, 'resize')
			.pipe(
				debounceTime(250),
				map(() => window.innerWidth),
				distinctUntilChanged(),
				startWith(window.innerWidth),
				tap(width => this.screen.setWindowWidth(Number(width)))
			);

		this.bookAwardFlight$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.bookAwardFlight = value;
			});

		this.current_step$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.current_step = value;
				this.flight_total = '';
			});

		this.timeToThink$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.timeToThink = value;
			});

		this.miles$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.milesInfo = value;
			});

		this.flightFilter$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => this.flightFilter = value);

		this.hasChanges$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(([booking_steps, costsPerDay]) => {
				const date = this.dateService.INDRA_formatParsedDate(booking_steps[this.current_step].date, 'DDMMYYYY');
				if (costsPerDay) {
					const price = costsPerDay[this.current_step].find(day => this.dateService.INDRA_formatParsedDate(day.date, 'DDMMYYYY') === date);
					if (price && price.ammount) this.calendarLowestPrice = this.bookAwardFlight ? price.ammount.points : price.ammount.currency.value;
				}
			});

		this.seachRoute$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((seachRoute): any => {
				this.searchRoute = seachRoute[0];
			});

		this.routeType$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(routeType => {
				this.tripType = routeType;
			});

		this.flightFareInformation$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(flightFareInformation => {
				if (!flightFareInformation) { 
					this.selected_brand = undefined;
					this.selectedBrandName = '';
					this.flight_total = this.INDRA_flight_total();
				}

				this.flightFareInformation = flightFareInformation;
			});

		this.booking_steps$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.booking_steps = value;
			});
	}

	ngOnInit() {
		this.resize$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe();

		this.currency = this.currencyService.INDRA_getCurrencySymbol().unit;

		this.flight = Object.assign({}, this.flightInfo);
		const cloneBrandsList = _.cloneDeep(this.flight.brandList);

		cloneBrandsList.forEach(brandlist => {
			brandlist.brands.forEach(brand => {
				if (this.current_step == 0) {
					brand.price = brand.offer.outbound.totalPrice.price;
					if (this.bookAwardFlight) {
						brand.bookAwardValue = brand.offer.outbound.totalPoints.price;
					}
				} else if (this.current_step == 1) {
					brand.price = brand.offer.inbound.totalPrice.price;
					if (this.bookAwardFlight) {
						brand.bookAwardValue = brand.offer.inbound.totalPoints.price;
					}
				}
			});
		});

		for (const i in cloneBrandsList) {
			if (this.bookAwardFlight) {
				cloneBrandsList[i].brands.sort(function (a, b) { return a.bookAwardValue - b.bookAwardValue; });
			} else {
				cloneBrandsList[i].brands.sort(function (a, b) { return a.price - b.price; });
			}
		}

		if (!this.bookAwardFlight) {

			for (const x in cloneBrandsList) {
				if (cloneBrandsList[x].brands.length > 0) {
					let isSorted = true;
					const sortedBrands = this.INDRA_sortBrands(x, cloneBrandsList);
					for (const i in cloneBrandsList[x].brands) {
						if (cloneBrandsList[x].brands[i].name != sortedBrands[i].name) {
							isSorted = false;
							break;
						}
					}

					if (!isSorted) {
						cloneBrandsList[x].brands = _.cloneDeep(sortedBrands);
					}
				}
			}
		}

		this.flight.brandList = _.cloneDeep(cloneBrandsList);

		this.brandsList = [];
		for (let i = 0; i < this.flight.brandList.length; i++) {
			if (this.flight.brandList[i].brands.length == 0) {
				this.brandsList[i] = Object.assign({}, this.flight.brandList[i], { status: 'sold out' });
			} else {
				this.brandsList[i] = Object.assign({}, this.flight.brandList[i], { status: 'ok' });
			}
		}

		this.isCodeShare = this.bookingSearchService.INDRA_isCodeShareFlight(this.flight);
		if (!this.INDRA_isDirectFlight()) {
			this.isMixedCabinFlightTrip = this.INDRA_isMixedCabinFlightTrip(this.flight);
		}

		this.isTAPCarrier = this.INDRA_isTAP();

		this.hasLastSeats = this.brandsList.find(brandList => brandList.brands.find(brand => brand.hasLastSeats && brand.LastSeatFlightId.includes(this.flight.idFlight))) ? true : false;
	}

	ngAfterViewInit() {
		this.bfmDataStorage.INDRA_getAvailabilityDatelist()
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(matrix => {
				if (matrix) this.matrixLowestPrice = this.INDRA_retrieveMatrixLowestPrice(matrix);
				this.hasLowestPrice = this.lowestAdtPrice === this.matrixLowestPrice ? true : false;
				this.cdr.detectChanges();
			});

		// window.scrollTo(0, 0);
	}

	ngOnDestroy() {
		this.isAlive = false;
		this.store.dispatch(new FlightResultActions.ResetAction());
		for (const sub of this.allSubs) {
			if (sub) {
				sub.unsubscribe();
			}
		}

		sessionStorage.removeItem('ancMealLabelSegments');
	}

	/**
	 * @returns brand state for animation based on selected_cabin
	 */
	get INDRA_brandsState(): 'expanded' | 'collapsed' {
		if (this.selected_cabin !== undefined) {
			return 'expanded';
		} else {
			return 'collapsed';
		}
	}

	/**
	 * @returns state of nextStep container based on selected_brand
	 */
	// note: unused, but referenced in a commented out code in the template
	get INDRA_nextStepState(): 'expanded' | 'collapsed' {
		if (this.selected_brand !== undefined) {
			return 'expanded';
		} else {
			return 'collapsed';
		}
	}

	/**
	 * @returns tolal price to pay for the selected brand
	 */
	INDRA_flight_total(): string {
		if (this.selected_cabin !== undefined &&
			this.selected_brand !== undefined) {
			const brand = this.brandsList[this.selected_cabin].brands[
				this.selected_brand
			];
			return (brand.price).toFixed(2);
		}
		return '0';
	}

	INDRA_bookAwardPrice(total) {
		if (this.bookAwardFlight)
			return `${(total).toLocaleString('pt')} M`;

		return '';
	}

	/**
	 * Handles @cabin selection.
	 * Emits to parent (through an observable), that a flight was selected
	 * to close all other flight results;
	 * @param cabin {number} cabin to select
	 */
	INDRA_selectCabin(cabin: number, $event?) {
		this.store.dispatch(new FlightResultActions.PutSelectedFlightAction(this.flight));
		if (this.isOpen && this.selected_cabinIndex !== cabin) {
			this.isOpen = true;
		} else {
			this.isOpen = !this.isOpen;
		}

		this.selected_cabinIndex = cabin;
		this.selected_cabin = cabin;
		this.INDRA_getAllAncillaryListByBrand();

		clearTimeout(this.scrollToTimeout); // needed to scroll properly to selected cabin
		if (this.isOpen)
			this.scrollToTimeout = setTimeout(() => {
				if ($event) {
					this.pageScrollService.scroll({
						document: this.document,
						scrollTarget: $event.target.closest('.app-flight-result'),
						duration: 400,
					});
				}
			}, 300);

		this.selectCabin.emit({ isOpen: this.isOpen, flight: this.flight });
	}

	/**
	 * @param brandName {string}
	 * @returns brand object from brand name
	 */
	getBrand(brandName: string) {
		let brand;
		if (this.selected_cabin) {
			brand = this.brands[this.selected_cabin].filter(
				e => e.name === brandName
			)[0];
		}
		return brand;
	}

	/**
	 * Handle brand selection
	 * @param brand {Brand}
	 */
	INDRA_selectBrand(brandIndex) {
		this.selected_brand = brandIndex;
		this.selectedBrandName = this.brandsList[this.selected_cabin].brands[this.selected_brand].name;
		this.flight_total = this.INDRA_flight_total();

		this.ancMealLabelSegments = [];
		this.ancFastTrackSegments = [];
		this.ancLoungeSegments = [];
	}

	INDRA_isSelected(index: number): boolean {
		return this.selected_brand == index;
	}

	/**
	 * Handle brand selection and confirm (on mobile)
	 * @param brand {Brand}
	 */
	INDRA_selectConfirmBrand(brandIndex) {
		this.INDRA_selectBrand(brandIndex);
		this.INDRA_handleSelectFlight();
	}

	INDRA_brandsStyles(listIndex) {
		const BRANDS_LENGTH = this.brandsList[listIndex].brands.length > 1 ? this.brandsList[listIndex].brands.length : 2;
		const COLS_DESKTOP = 12 / BRANDS_LENGTH;
		const COLS_MOBILE = 12;

		return 'col-p-' + COLS_MOBILE + ' col-tp-' + COLS_MOBILE + ' col-tl-' + COLS_DESKTOP + ' col-' + COLS_DESKTOP;
	}

	INDRA_showBrands(listIndex) {
		return this.selected_cabin === listIndex && this.showDetails;
	}

	INDRA_finalPrice(brands) {
		const lowestPrice = this.INDRA_printLowestPrice(brands);

		if (this.milesInfo !== 'cash') {
			return this.INDRA_bookAwardPrice(lowestPrice);
		}

		let discountMiles = 0;
		if (this.flight.milesGoDiscount) {
			if (this.tripType === 'R') {
				discountMiles = this.discountMiles / 2;
			} else {
				discountMiles = this.discountMiles;
			}
		}

		if (this.isLoggedIn) {
			return (lowestPrice - discountMiles).toFixed(2);
		} else {
			return lowestPrice.toFixed(2);
		}
		
	}

	INDRA_printLowestPrice(brands) {
		if (brands.length != 0) {
			if (this.bookAwardFlight) {
				const lowest_points = brands.reduce(function (prev, curr) {
					return prev.bookAwardValue < curr.bookAwardValue ? prev : curr;
				});

				return parseFloat(lowest_points.bookAwardValue);
			} else {
				const lowest_price = brands.reduce(function (prev, curr) {
					return prev.price < curr.price ? prev : curr;
				});

				return parseFloat(lowest_price.price);
			}
		}
	}

	// Check for new aamOriginalPrice regardless if loggedin or not.
	// If present display the aamOriginalPrice with strikethrough
	INDRA_getLowestAAMOriginalPrice(brands): number | null {
		const aamPrices = [];
		for (let i = 0; i < brands.length; i++) {
			const brand = brands[i];
			const bound = this.current_step === 0 ? 'outbound' : 'inbound';
			if (
				brand &&
				brand.offer &&
				brand.offer[bound] &&
				brand.offer[bound].totalPrice &&
				typeof brand.offer[bound].totalPrice.aamOriginalPrice === 'number'
			) {
				aamPrices.push(brand.offer[bound].totalPrice.aamOriginalPrice);
			}
		}
		return aamPrices.length > 0 ? Math.min.apply(null, aamPrices) : null;
	}

	/**
	 * Adds flight to the booking
	 * Fails if flight departure time is not readily available
	 */
	INDRA_handleSelectFlight() {
		const additionalDetails = this.flight.brandList[this.selected_cabin].brands[this.selected_brand];
		if (additionalDetails) {
			this.flight = Object.assign({}, this.flight, {
				options: {
					price: parseFloat(this.flight_total),
					tax: additionalDetails.tax,
					brand: additionalDetails,
					currency: this.currency
				}
			});

			const departureDateTime = new Date(this.dateService.INDRA_formatDate(this.flight.listSegment[0].departureDate, 'MM/DD/YYYY HH:mm'));
			if (this.bookingService.isLastStep()) {
				if (!this.timeToThink) {
					// this.bookingSearchService.setFlight(this.flight, departureDateTime);
					this.bookingService.updateFooterData('flights', {flight: this.flight, time: departureDateTime});
				} else {
					this.bookingService.setTimeToThink(this.timeToThink);
					// this.bookingSearchService.setFlight(this.flight, departureDateTime);
					this.bookingService.updateFooterData('flights', {flight: this.flight, time: departureDateTime});
				}
			} else {
				// this.bookingSearchService.setFlight(this.flight, departureDateTime);
				this.bookingService.updateFooterData('flights', {flight: this.flight, time: departureDateTime});

				// if RT and selected outbound flight has no milesGoDiscount, remove milesGoDiscount of inbound flights 
				if (!this.flight.milesGoDiscount) {
					this.store.dispatch(new MilesBarActions.SetDiscountInformationMiles({ cash: 0, miles: 0 }));
					this.store.dispatch(new FlightsFilterActions.PutFlightWithMiles(false));
				}

				this.brandSelected.emit(true);
			}
		}
	}

	INDRA_printAriaLabel(brand) {
		return `${brand.label} ${brand.label_sufix} ${this.INDRA_printLowestPrice(brand.brands)} ${this.currency}`;
	}

	INDRA_openCompareFares(index) {
		this.modalService.assignComponent(INDRACompareFareModalComponent, { brand: index, availableBrands: this.flight.brandList });
		this.modalService.open();
	}

	INDRA_checkAvailability(index): boolean {
		if (this.brandsList[index].status == 'sold out') {
			return false;
		}
		return true;
	}


	INDRA_isLowestFare(brand) {
		const lowestAdtPrice = this.INDRA_getLowestAdtPrice(brand.brands);
		this.lowestAdtPrice = !this.lowestAdtPrice ? lowestAdtPrice : this.lowestAdtPrice < lowestAdtPrice ? this.lowestAdtPrice : lowestAdtPrice;

		if (lowestAdtPrice === this.matrixLowestPrice) {
			return true;
		}
		return false;
	}

	INDRA_isLowestPriceUpdated() {
		if (this.matrixLowestPrice && this.calendarLowestPrice && this.lowestAdtPrice) {
			if (this.lowestAdtPrice === this.matrixLowestPrice && this.lowestAdtPrice != this.calendarLowestPrice) {
				return true;
			}
			return false;
		}
		return false;
	}

	INDRA_getLowestAdtPrice(brands) {
		if (brands.length != 0) {
			const bound = this.current_step === 0 ? 'outbound' : 'inbound';
			if (this.bookAwardFlight) {
				const lowest_price = brands.reduce((prev, curr) => {
					const prevListPaxPoints = prev.offer && prev.offer[bound] ? this.INDRA_getAdtPrice(prev.offer[bound], true) : prev;
					const currListPaxPoints = curr.offer && curr.offer[bound] ? this.INDRA_getAdtPrice(curr.offer[bound], true) : curr;

					return prevListPaxPoints.price < currListPaxPoints.price ? prevListPaxPoints : currListPaxPoints;
				});

				const adtPrice = brands.length === 1 ? this.INDRA_getAdtPrice(brands[0].offer[bound], true) : lowest_price;
				return parseFloat(adtPrice.price);
			} else {
				const lowest_price = brands.reduce((prev, curr) => {
					const prevListPaxPrice = prev.offer && prev.offer[bound] ? this.INDRA_getAdtPrice(prev.offer[bound], false) : prev;
					const currListPaxPrice = curr.offer && curr.offer[bound] ? this.INDRA_getAdtPrice(curr.offer[bound], false) : curr;

					return prevListPaxPrice.price < currListPaxPrice.price ? prevListPaxPrice : currListPaxPrice;
				});

				const adtPrice = brands.length === 1 ? this.INDRA_getAdtPrice(brands[0].offer[bound], false) : lowest_price;
				return parseFloat(adtPrice.price);
			}
		}
	}

	INDRA_getAdtPrice(bound: any, award: boolean) {
		const prop = award ? 'listPaxPoints' : 'listPaxPrice';
		const adtPrice = bound[prop].find(pax => pax.typePax === PAX_TYPE_ADULT_CODE);
		return adtPrice ? adtPrice : bound[prop].find(pax => pax.typePax === PAX_TYPE_YOUNG_ADULT_CODE);
	}

	INDRA_retrieveMatrixLowestPrice(matrix: any) {
		if (this.booking_steps && matrix[this.current_step]) {

			const date = this.dateService.INDRA_formatParsedDate(this.booking_steps[this.current_step].date, 'DDMMYYYY');
			const day = matrix[this.current_step].find(day => this.dateService.INDRA_formatParsedDate(day.date, 'DDMMYYYY') === date);

			return day ? day.price : null;
		}

		return null;
	}

	INDRA_hasLastSeatsAlert() {
		for (const i in this.brandsList) {
			if (this.brandsList[i].status === 'sold out') {
				continue;
			}

			if (this.brandsList[i].last_seats) {
				return true;
			}
		}

		return false;
	}

	INDRA_handleDetailsFeature(feature, brand) {
		if (this.clickFeature) {
			const flightObj = Object.assign({}, this.flight, {
				options: { brand: brand.name }
			});
			this.clickFeature.emit({ feature, brand, flight: this.flight.idFlight, flightInfo: flightObj });
		}
	}

	INDRA_isTAP(): boolean {
		for (let x = 0; x < this.flight.listSegment.length; x++) {
			if (this.flight.listSegment[x].carrier == AIRLINE_TAP_CODE) {
				return true;
			}
		}
		return false;
	}

	INDRA_displayFlightSelectionImage() {
		return (!this.isMobile) || (this.isMobile && !this.isCodeShare);
	}

	INDRA_showWarning(option: number): boolean {
		switch (option) {
			case 0:
				return (this.brandsList.length - 1 === this.selected_cabinIndex)
					&& this.isMixed;
			case 1:
				return this.isCodeShare;
			case 2:
				// note: possible dummy logic
				return this.isTAPCarrier && (this.searchRoute.arrival.location.country === 'South Africa'
					|| this.searchRoute.departure.location.country === 'South Africa');
			case 3:
				return this.flight.embargoWarning && this.flight.embargoStartDate && this.flight.embargoEndDate;
			case 4:
				let brands = this.flight.brandList[this.selected_cabin].brands;
				return BUSINESS_BRANDS.some(brand =>
					brands.map(brnd => brnd.name.toUpperCase()).includes(brand.toUpperCase())
				) && this.flight.economyWarning;
			default:
				break;
		}
		return false;
	}

	INDRA_isDirectFlight(): boolean {
		return this.flight.numberOfStops === 0;
	}

	INDRA_isMixedCabinFlightTrip(flight) {
		let isMixedCabinFlightTrip = false;
		this.starAwardsFlightMixedWithEconomy = false;
		this.starAwardsFlightMixedWithExecutive = false;
		const economyFlightSegmentNumbers = [];

		if (flight && flight.brandList && flight.brandList.length > 0) {
			if (!this.bookAwardFlight && !this.flightFilter.starAlliance) {
				// (a) commercial flights	
				const executiveBrand = flight.brandList.filter(brand => brand.label === 'Executive');
				if (executiveBrand && executiveBrand.length > 0 && executiveBrand[0].brands) {
					executiveBrand[0].brands.forEach(brand => {
						const bound = (this.current_step === 0) ? 'outbound' : 'inbound';
						const economyCabinRBDIndex = [];

						// get indexes of non-business cabins
						if (brand.offer[bound].isMixedCabin != null){
							this.isMixed = true;
							brand.offer[bound].isMixedCabin.forEach((value, index) => {
								if (value) {
									economyCabinRBDIndex.push(index);
								}
							});
						}

						if (economyCabinRBDIndex.length > 0) {
							isMixedCabinFlightTrip = true;
							economyCabinRBDIndex.forEach(idx => {
								const economyFlightSegment = flight.listSegment[idx];
								const economyFlightNumber = economyFlightSegment.carrier + economyFlightSegment.flightNumber;
								if (!economyFlightSegmentNumbers.includes(economyFlightNumber)) {
									economyFlightSegmentNumbers.push(economyFlightNumber);
								}
							});
						}
					});
				}
			} else if (this.bookAwardFlight && !this.flightFilter.starAlliance) {
				// (b) TAP awards only flight
				const brandGroup = flight.brandList[0];
				if (brandGroup.brands && brandGroup.brands.length > 0) {
					const executiveBrand = brandGroup.brands.filter(brand => brand.name.includes('executive'));
					if (executiveBrand && executiveBrand.length > 0 && executiveBrand[0]) {
						const bound = (this.current_step === 0) ? 'outbound' : 'inbound';
						const economyCabinRBDIndex = [];

						// get indexes of non-business cabins
						if (executiveBrand[0].offer[bound].isMixedCabin != null){
							this.isMixed = true;
							executiveBrand[0].offer[bound].isMixedCabin.forEach((value, index) => {
								if (value) {
									economyCabinRBDIndex.push(index);
								}
							});
						}

						if (economyCabinRBDIndex.length > 0) {
							isMixedCabinFlightTrip = true;
							economyCabinRBDIndex.forEach(idx => {
								const economyFlightSegment = flight.listSegment[idx];
								const economyFlightNumber = economyFlightSegment.carrier + economyFlightSegment.flightNumber;
								if (!economyFlightSegmentNumbers.includes(economyFlightNumber)) {
									economyFlightSegmentNumbers.push(economyFlightNumber);
								}
							});
						}
					}
				}
			} else if (this.bookAwardFlight && this.flightFilter.starAlliance) {
				// (c) STAR alliance awards only flight
				const brandGroup = flight.brandList[0];
				if (brandGroup.brands && brandGroup.brands.length > 0) {
					const executiveBrand = brandGroup.brands.filter(brand => brand.name.includes('business') || brand.name.includes('first'));
					if (executiveBrand && executiveBrand.length > 0) {
						executiveBrand.forEach(brand => {
							const bound = (this.current_step === 0) ? 'outbound' : 'inbound';
							const economyCabinRBDIndex = [];

							// get indexes of non-business cabins
							if(brand.offer[bound].isMixedCabin != null){
								this.isMixed = true;
								brand.offer[bound].isMixedCabin.forEach((value, index) => {
									if (value) {
										economyCabinRBDIndex.push(index);
									}
								});
							}

							if (brand.name.includes('business') && (brand.offer[bound].rbd.includes('X') || brand.offer[bound].rbd.includes('I')) &&
								!brand.offer[bound].rbd.includes('O')) {
								this.starAwardsFlightMixedWithEconomy = true;
							}

							if (brand.name.includes('first') && (brand.offer[bound].rbd.includes('O') || brand.offer[bound].rbd.includes('I'))) {
								this.starAwardsFlightMixedWithExecutive = true;
							}

							if (economyCabinRBDIndex.length > 0) {
								isMixedCabinFlightTrip = true;
								economyCabinRBDIndex.forEach(idx => {
									const economyFlightSegment = flight.listSegment[idx];
									const economyFlightNumber = economyFlightSegment.carrier + economyFlightSegment.flightNumber;
									if (!economyFlightSegmentNumbers.includes(economyFlightNumber)) {
										economyFlightSegmentNumbers.push(economyFlightNumber);
									}
								});
							}
						});
					}
				}
			}
		}

		if (economyFlightSegmentNumbers.length > 0) {
			this.economyFlightSegmentNumbers =
				economyFlightSegmentNumbers.reduce((acc, curr) => (acc !== '' ? acc + ', ' + curr : curr));
		}

		return isMixedCabinFlightTrip;
	}

	INDRA_printLabel(label) {

		if (label === "Economy") {
			label = this.ibeAdminService.getTranslationValue('availability.flightsPage.text.economy');
		} else if (label === "Executive") {
			label = this.ibeAdminService.getTranslationValue('availability.flightsPage.text.executive');
		} else if (label === "First") {
			label = this.ibeAdminService.getTranslationValue('availability.flightsPage.text.first')
		}

		if (this.brandsList[0]['slug'] === 'miles&go') {
			let economyAvailability = 1;
			let executiveAvailability = 1;
			this.brandsList[0].brands.forEach(brand => {
				const brandClass = brand.name.split('-')[1];
				if (brand.state != 'available') {
					if (brandClass == 'executive') {
						executiveAvailability--;
					} else {
						economyAvailability--;
					}
				} else {
					if (brandClass == 'executive') {
						executiveAvailability++;
					} else {
						economyAvailability++;
					}
				}
			});

			if (economyAvailability && !executiveAvailability || !economyAvailability && !executiveAvailability) {
				label = this.ibeAdminService.getTranslationValue('availability.flightsPage.text.economyunavailableexec');
			} else if (!economyAvailability && executiveAvailability) {
				label = this.ibeAdminService.getTranslationValue('availability.flightsPage.text.unavailableeconomyexec');
			} else {
				label = this.ibeAdminService.getTranslationValue('availability.flightsPage.text.economyexecutive');
			}
		} else if (this.brandsList[0]['slug'] === 'staralliance') {
			let economyAvailability = false;
			let businessAvailability = false;
			let firstAvailability = false;
			this.brandsList[0].brands.forEach(brand => {
				const brandClass = brand.name.split('-')[1];
				if (brandClass == 'business') {
					businessAvailability = true;
				} else if (brandClass == 'first') {
					firstAvailability = true;
				} else if (brandClass == 'economy') {
					economyAvailability = true;
				}
			});
			label = (economyAvailability) ? this.ibeAdminService.getTranslationValue('availability.flightsPage.text.economyCaps') : this.ibeAdminService.getTranslationValue('availability.flightsPage.text.economyUnavailable');
			label += ' / ';
			label += (businessAvailability) ? this.ibeAdminService.getTranslationValue('availability.flightsPage.text.executiveCaps') : this.ibeAdminService.getTranslationValue('availability.flightsPage.text.executiveUnavailable');
			label += ' / ';
			label += (firstAvailability) ? this.ibeAdminService.getTranslationValue('availability.flightsPage.text.firstCaps') : this.ibeAdminService.getTranslationValue('availability.flightsPage.text.firstUnavailable');
		}

		return label;
	}

	INDRA_getLabel(label) {
		if (label === "Economy") {
			return 'availability.flightsPage.text.economy';
		} else if (label === "Executive") {
			return 'availability.flightsPage.text.executive';
		} else if (label === "First") {
			return 'availability.flightsPage.text.first';
		}

		return '';
	}

	INDRA_getAllAncillaryListByBrand() {
		if (this.flight.bound && this.flight) {
			const flightDetail = this.INDRA_getFlightDetails(this.flight);
			const tempData = Object.assign({}, this.flight);

			// reset value of fare Information
			this.store.dispatch(new FlightFareInformationActions.
				PutSelectedFlightFareInformationAction(null));

			const tempBrandData = [];
			for (let i = 0; i < this.flight.brandList.length; i++) {
				tempBrandData[i] = this.flight.brandList[i].brands.map((item) =>
					Object.assign({}, item, {
						'ancillaries': null,
						'includedAncillaries': null,
						'changes': null,
						'changes-fee': null,
						'changes-description': null,
						'refunds': null,
						'refounds-fee': null,
						'refunds-description': null,
						'milesPercentage': null,
						'miles': null,
						'actualMiles': null,
						'economy-extra-elegible': null,
						'extra-ancillaries': null
					})
				);
			}
			Object.defineProperty(tempData, 'brandList', {
				writable: true
			});
			tempData.brandList = [];

			for (let i = 0; i < this.flight.brandList.length; i++) {
				tempData.brandList[i] = {
					'label': this.flight.brandList[i].label,
					'slug': this.flight.brandList[i].slug,
					'label_sufix': this.flight.brandList[i].label_sufix,
					'brands': tempBrandData[i],
				};
			}
			this.flight = Object.assign({}, tempData);

			if (flightDetail) {
				this.flight.brandList.forEach((item) => {
					item.brands.forEach((brandItem) => {
						let fareBasis = brandItem.offer[this.flight.bound].fareFamily;
						if (this.flightFilter.starAlliance) {
							fareBasis = brandItem.offer[this.flight.bound].fareBasis;
						}
						const tempItinerary = [];

						for (const i in flightDetail.itinerary) {
							tempItinerary.push({
								origin: flightDetail.itinerary[i].origin,
								destination: flightDetail.itinerary[i].destination,
								operatingCarrier: flightDetail.itinerary[i].operationCarrier,
								flightNumber: flightDetail.itinerary[i].flightNumber,
								equipment: flightDetail.itinerary[i].equipment,
								carrier: flightDetail.itinerary[i].carrier,
								rbd: brandItem.offer[this.flight.bound].rbd[i],
								duration: flightDetail.itinerary[i].duration,
							});
						}
						const request: INDRAFareInformationRequest = {
							origin: flightDetail['origin'],
							destination: flightDetail['destination'],
							fareBasis: fareBasis,
							fareFamily: brandItem.offer[this.flight.bound].fareFamily,
							marketingCarrier: flightDetail['carrier'],
							tripType: this.tripType,
							itinerary: tempItinerary
						};

						const fareInfoSubscription = this.INDRA_getAncillaryListByBrand(request).subscribe(data => {
							if (data.status == '200') {
								if (data.fareInformationData && Object.keys(data.fareInformationData).length !== 0) {
									let indexesTAC = Object.keys(data.fareInformationData);
									let mealsIncludedSegmentList = [];
									let hasMealChecker = [];
									let hasAncHasMealDataStore;
									let hasAncHasNoMealDataStore;
									indexesTAC.map(index => {
										let fareInfoData = data.fareInformationData[index];
										if (fareInfoData &&
											fareInfoData['basic-ancillaries'] &&
											fareInfoData['basic-ancillaries'].length > 0) {
											brandItem['ancillaries'] = data.basicAncillariesGlobal && data.basicAncillariesGlobal.length ? data.basicAncillariesGlobal : fareInfoData['basic-ancillaries'];
											brandItem['includedAncillaries'] = fareInfoData['ancillaries'];
											brandItem['changes'] = fareInfoData.changes;
											brandItem['changes-fee'] = fareInfoData['changes-fee'];
											brandItem['changes-description'] = fareInfoData['changes-description'];
											brandItem['refunds'] = fareInfoData.refunds;
											brandItem['refounds-fee'] = fareInfoData['refounds-fee'];
											brandItem['refunds-description'] = fareInfoData['refunds-description'];
											brandItem['milesPercentage'] = fareInfoData['milesPercentage'];
											brandItem['miles'] = fareInfoData['miles'];
											brandItem['totalMiles'] = fareInfoData['totalMiles'];
											brandItem['actualMiles'] = fareInfoData['actualMiles'];
											brandItem['economy-extra-elegible'] = fareInfoData['economy-extra-elegible'];
											brandItem['extra-ancillaries'] = fareInfoData['extra-ancillaries'];
											brandItem['red-and-green-elegible'] = fareInfoData['red-and-green-elegible'];
											brandItem['no-show'] = fareInfoData['no-show'];
											brandItem['no-show-fee'] = fareInfoData['no-show-fee'];
											brandItem['mealImage'] = fareInfoData['mealImage'];
											brandItem['mealImageBySegment'] = fareInfoData['mealImageBySegment'];

											fareInfoData['ancillaries'].map(data => {
												if (data == 'MEALS') {
													hasMealChecker.push(true);
													mealsIncludedSegmentList.push(index);
													hasAncHasMealDataStore = fareInfoData;
													brandItem['fareInfo-segment'] = mealsIncludedSegmentList;
												} else {
													hasMealChecker.push(false);
													hasAncHasNoMealDataStore = fareInfoData;
												}
											});
										} else {
											hasMealChecker.push(false);
										}
									});

									if (hasMealChecker.includes(true)) {
										brandItem['ancillaries'] = data.basicAncillariesGlobal && data.basicAncillariesGlobal.length ? data.basicAncillariesGlobal : hasAncHasMealDataStore['basic-ancillaries'];
										brandItem['includedAncillaries'] = hasAncHasMealDataStore['ancillaries'];
										brandItem['changes'] = hasAncHasMealDataStore.changes;
										brandItem['changes-fee'] = hasAncHasMealDataStore['changes-fee'];
										brandItem['changes-description'] = hasAncHasMealDataStore['changes-description'];
										brandItem['refunds'] = hasAncHasMealDataStore.refunds;
										brandItem['refounds-fee'] = hasAncHasMealDataStore['refounds-fee'];
										brandItem['refunds-description'] = hasAncHasMealDataStore['refunds-description'];
										brandItem['milesPercentage'] = hasAncHasMealDataStore['milesPercentage'];
										brandItem['miles'] = hasAncHasMealDataStore['miles'];
										brandItem['totalMiles'] = hasAncHasMealDataStore['totalMiles'];
										brandItem['actualMiles'] = hasAncHasMealDataStore['actualMiles'];
										brandItem['economy-extra-elegible'] = hasAncHasMealDataStore['economy-extra-elegible'];
										brandItem['extra-ancillaries'] = hasAncHasMealDataStore['extra-ancillaries'];
										brandItem['red-and-green-elegible'] = hasAncHasMealDataStore['red-and-green-elegible'];
										brandItem['no-show'] = hasAncHasMealDataStore['no-show'];
										brandItem['no-show-fee'] = hasAncHasMealDataStore['no-show-fee'];
										brandItem['mealImage'] = hasAncHasMealDataStore['mealImage'];
										brandItem['mealImageBySegment'] = hasAncHasMealDataStore['mealImageBySegment'];
									} else {
										if (hasAncHasNoMealDataStore) {
											brandItem['ancillaries'] = data.basicAncillariesGlobal && data.basicAncillariesGlobal.length ? data.basicAncillariesGlobal : hasAncHasNoMealDataStore['basic-ancillaries'];
											brandItem['includedAncillaries'] = hasAncHasNoMealDataStore['ancillaries'];
											brandItem['changes'] = hasAncHasNoMealDataStore.changes;
											brandItem['changes-fee'] = hasAncHasNoMealDataStore['changes-fee'];
											brandItem['changes-description'] = hasAncHasNoMealDataStore['changes-description'];
											brandItem['refunds'] = hasAncHasNoMealDataStore.refunds;
											brandItem['refounds-fee'] = hasAncHasNoMealDataStore['refounds-fee'];
											brandItem['refunds-description'] = hasAncHasNoMealDataStore['refunds-description'];
											brandItem['milesPercentage'] = hasAncHasNoMealDataStore['milesPercentage'];
											brandItem['miles'] = hasAncHasNoMealDataStore['miles'];
											brandItem['totalMiles'] = hasAncHasNoMealDataStore['totalMiles'];
											brandItem['actualMiles'] = hasAncHasNoMealDataStore['actualMiles'];
											brandItem['economy-extra-elegible'] = hasAncHasNoMealDataStore['economy-extra-elegible'];
											brandItem['extra-ancillaries'] = hasAncHasNoMealDataStore['extra-ancillaries'];
											brandItem['red-and-green-elegible'] = hasAncHasNoMealDataStore['red-and-green-elegible'];
											brandItem['no-show'] = hasAncHasNoMealDataStore['no-show'];
											brandItem['no-show-fee'] = hasAncHasNoMealDataStore['no-show-fee'];
											brandItem['mealImage'] = hasAncHasNoMealDataStore['mealImage'];
											brandItem['mealImageBySegment'] = hasAncHasNoMealDataStore['mealImageBySegment'];
										} else {
											brandItem['ancillaries'] = [];
											brandItem['includedAncillaries'] = null;
											brandItem['changes'] = null;
											brandItem['changes-fee'] = null;
											brandItem['changes-description'] = null;
											brandItem['refunds'] = null;
											brandItem['refounds-fee'] = null;
											brandItem['refunds-description'] = null;
											brandItem['milesPercentage'] = null;
											brandItem['miles'] = null;
											brandItem['totalMiles'] = null;
											brandItem['actualMiles'] = null;
											brandItem['economy-extra-elegible'] = null;
											brandItem['extra-ancillaries'] = null;
											brandItem['red-and-green-elegible'] = null;
											brandItem['no-show'] = null;
											brandItem['no-show-fee'] = null;
											brandItem['mealImage'] = null;
											brandItem['mealImageBySegment'] = null;
										}
										this.cdr.detectChanges();

									}
									// save flight brand fare information to store
									this.INDRA_persistFlightBrandFareInformation(brandItem);
								}
								else {
									brandItem['ancillaries'] = [];
									brandItem['includedAncillaries'] = null;
									brandItem['changes'] = null;
									brandItem['changes-fee'] = null;
									brandItem['changes-description'] = null;
									brandItem['refunds'] = null;
									brandItem['refounds-fee'] = null;
									brandItem['refunds-description'] = null;
									brandItem['milesPercentage'] = null;
									brandItem['miles'] = null;
									brandItem['totalMiles'] = null;
									brandItem['actualMiles'] = null;
									brandItem['economy-extra-elegible'] = null;
									brandItem['extra-ancillaries'] = null;
									brandItem['red-and-green-elegible'] = null;
									brandItem['no-show'] = null;
									brandItem['no-show-fee'] = null;
									brandItem['mealImage'] = null;
								}

								this.cdr.detectChanges();
							} else {
								brandItem['ancillaries'] = [];
								brandItem['includedAncillaries'] = null;
								this.cdr.detectChanges();
							}
						}, error => {
							brandItem['ancillaries'] = [];
							brandItem['includedAncillaries'] = null;
							this.cdr.detectChanges();
						});

						this.allSubs.push(fareInfoSubscription);
					});
				});
			}
		}
	}

	/**
	 *	Store flight brand to the store for retrieving and processing later on.
	 *  Note that the store contents should be reset if the user opens another flight
	 */
	INDRA_persistFlightBrandFareInformation(flightBrand) {
		if (!this.flightFareInformation || this.flightFareInformation.length === 0) {
			this.flightFareInformation = [];
		}

		// check if current brand is existing in the list
		// const hasExistingFareInfo = this.flightFareInformation.filter(
		// 	fareInfo => fareInfo && fareInfo.name === flightBrand.name);

		// only add to the list, and onto the store if brand is not yet existing
		// if (hasExistingFareInfo.length === 0) {
		const editableFlightFareInformationList = _.cloneDeep(this.flightFareInformation);
		editableFlightFareInformationList.push(flightBrand);
		this.store.dispatch(new FlightFareInformationActions.
			PutSelectedFlightFareInformationAction(editableFlightFareInformationList));
		// }
	}

	INDRA_getFlightDetails(flight) {

		if (flight) {
			const flightDetail = {
				destination: null,
				carrier: null,
				origin: null,
				itinerary: [],
			};
			const segmentLength = flight.listSegment.length;
			flightDetail['destination'] = flight.listSegment[segmentLength - 1].arrivalAirport;
			flightDetail['carrier'] = flight.listSegment[0].carrier;
			flightDetail['origin'] = flight.listSegment[0].departureAirport;
			flightDetail['itinerary'] = [];
			for (const i in flight.listSegment) {
				flightDetail.itinerary[i] = {
					equipment: flight.listSegment[i].equipment,
					carrier: flight.listSegment[i].carrier,
					operationCarrier: flight.listSegment[i].operationCarrier,
					flightNumber: flight.listSegment[i].flightNumber,
					origin: flight.listSegment[i].departureAirport,
					destination: flight.listSegment[i].arrivalAirport,
					duration: flight.listSegment[i].duration
				};
			}

			//CASE: ADDITIONAL CONDITION FOR UPDATING THE O&D OF INBOUND FLIGHT BASED ON PROOF OF COMMENCEMENT
			if (flight.bound === 'inbound') {
				let refFlight: any = _.cloneDeep(flight);
				if (flight.listSegment && flight.listSegment.length > 1) {
					//CASE: INDIRECT FLIGHT (2 SEGMENTS)
					flightDetail.origin = refFlight.listSegment[1].arrivalAirport;
					flightDetail.destination = refFlight.listSegment[0].departureAirport;

				} else {
					//CASE: DIRECT FLIGHT (1 SEGMENT)
					flightDetail.origin = refFlight.listSegment[0].arrivalAirport;
					flightDetail.destination = refFlight.listSegment[0].departureAirport;
				}

			}
			return flightDetail;
		}
		return null;
	}

	INDRA_getAncillaryListByBrand(request): Observable<INDRAFareInformationResponse> {
		let response: Observable<INDRAFareInformationResponse> = this.ancillariesService.INDRA_getFareInformationTAC(request);
		this.INDRA_getMealAncSegments(response, this.flight, request);
		this.INDRA_getFastTrackAncSegments(response, this.flight, request);
		this.INDRA_getLoungeAncSegments(response, this.flight, request);

		return response;
	}

	INDRA_getMealAncSegments(infoTACData: any, selFlightData: any, request) {
		infoTACData
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(data => {
				let fareInfoData = data['fareInformationData'];
				let ancMealSegments = [];

				if (fareInfoData) {
					Object.keys(fareInfoData).map(ancSeg => {
						if (fareInfoData[ancSeg].ancillaries.includes('MEALS')) {
							ancMealSegments.push(ancSeg);
						} else {
							if (fareInfoData[ancSeg]['basic-ancillaries'].some(basic => basic.code === BASIC_ANCILLARY_CODES_MEALS)) {
								ancMealSegments.push(ancSeg);
							}
						}
					});

					if (ancMealSegments && ancMealSegments.length > 0) {
						ancMealSegments.map(seg => {
							this.ancMealLabelSegments.push(
								{
									route: selFlightData.listSegment[seg].departureAirport + '-' + selFlightData.listSegment[seg].arrivalAirport,
									flightId: selFlightData.idFlight,
									idSegment: selFlightData.listSegment[seg].idInfoSegment,
									fareFamily: request.fareFamily,
									mealImageBySegment: fareInfoData[seg].mealImageBySegment,
									mealImage: fareInfoData[seg].mealImage,
								}
							);
						});
					}
				}
				sessionStorage.setItem('ancMealLabelSegments', JSON.stringify(this.ancMealLabelSegments));
			});
	}

	INDRA_getFastTrackAncSegments(infoTACData: any, selFlightData: any, request) {
		infoTACData
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(data => {
				let fareInfoData = data['fareInformationData'];
				let ancFastTrackSegments = [];

				if (fareInfoData) {
					Object.keys(fareInfoData).map(ancSeg => {
						if (fareInfoData[ancSeg]['basic-ancillaries'].some(anc => anc.code === BASIC_ANCILLARY_CODES_FASTTRACK && anc.available && anc.free)) {
							ancFastTrackSegments.push(ancSeg);
						}
					});

					if (ancFastTrackSegments && ancFastTrackSegments.length > 0) {
						ancFastTrackSegments.map(seg => {
							this.ancFastTrackSegments.push(
								{
									route: selFlightData.listSegment[seg].departureAirport + '-' + selFlightData.listSegment[seg].arrivalAirport,
									flightId: selFlightData.idFlight,
									idSegment: selFlightData.listSegment[seg].idInfoSegment,
									fareFamily: request.fareFamily
								}
							);
						});
					}
				}
				sessionStorage.setItem('ancFastTrackSegments', JSON.stringify(this.ancFastTrackSegments));
			});
	}

	INDRA_getLoungeAncSegments(infoTACData: any, selFlightData: any, request) {
		infoTACData
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(data => {
				let fareInfoData = data['fareInformationData'];
				let ancLoungeSegments = [];

				if (fareInfoData) {
					Object.keys(fareInfoData).map(ancSeg => {
						if (fareInfoData[ancSeg]['basic-ancillaries'].some(anc => anc.code === BASIC_ANCILLARY_CODES_LOUNGE && anc.available && anc.free)) {
							ancLoungeSegments.push(ancSeg);
						}
					});

					if (ancLoungeSegments && ancLoungeSegments.length > 0) {
						ancLoungeSegments.map(seg => {
							this.ancLoungeSegments.push(
								{
									route: selFlightData.listSegment[seg].departureAirport + '-' + selFlightData.listSegment[seg].arrivalAirport,
									flightId: selFlightData.idFlight,
									idSegment: selFlightData.listSegment[seg].idInfoSegment,
									fareFamily: request.fareFamily
								}
							);
						});
					}
				}
				sessionStorage.setItem('ancLoungeSegments', JSON.stringify(this.ancLoungeSegments));
			});
	}

	INDRA_getAncillaries(listIndex, brandIndex) {
		return this.flight.brandList[listIndex].brands[brandIndex].ancillaries;
	}

	INDRA_getIncludedAncillaries(listIndex, brandIndex) {
		return this.flight.brandList[listIndex].brands[brandIndex].includedAncillaries;
	}

	INDRA_getMilesToBeEarned(listIndex, brandIndex) {
		return this.flight.brandList[listIndex].brands[brandIndex].totalMiles;
	}

	INDRA_getBrand(listIndex, brandIndex) {
		return this.flight.brandList[listIndex].brands[brandIndex];
	}

	INDRA_isEconomyExtra(listIndex, brandIndex) {
		/*
		for (const i in this.flight.brandList[listIndex].brands) {
			if (this.flight.brandList[listIndex].brands[i]['economy-extra-elegible']) {
				return true;
			}
		}
		*/
		if (this.flight.brandList[listIndex].brands[brandIndex] && this.flight.brandList[listIndex].brands[brandIndex]['economy-extra-elegible']) {
			return true;
		}
		return false;
	}

	INDRA_hasBrandsWithEconomyExtra(listIndex) {
		for (const i in this.flight.brandList[listIndex].brands) {
			if (this.flight.brandList[listIndex].brands[i]['economy-extra-elegible']) {
				return true;
			}
		}
		return false;
	}

	INDRA_sortBrands(index, cloneBrandsList) {
		if (cloneBrandsList[index].slug == 'economy') {
			const sortedEconomyBrands = [];

			const discountBrand = cloneBrandsList[index].brands.filter(current => current.name == BRAND_CODE_DISCOUNT)[0];
			const basicBrand = cloneBrandsList[index].brands.filter(current => current.name == BRAND_CODE_BASIC)[0];
			const classicBrand = cloneBrandsList[index].brands.filter(current => current.name == BRAND_CODE_CLASSIC)[0];
			const plusBrand = cloneBrandsList[index].brands.filter(current => current.name == BRAND_CODE_PLUS)[0];

			if (discountBrand) {
				sortedEconomyBrands.push(discountBrand);
			}
			if (basicBrand) {
				sortedEconomyBrands.push(basicBrand);
			}
			if (classicBrand) {
				sortedEconomyBrands.push(classicBrand);
			}
			if (plusBrand) {
				sortedEconomyBrands.push(plusBrand);
			}

			return sortedEconomyBrands;

		} else if (cloneBrandsList[index].slug == 'executive') {
			const sortedBusinessBrands = [];

			const executiveBrand = cloneBrandsList[index].brands.filter(current => current.name == BRAND_CODE_EXECUTIVE)[0];
			const topExecutiveBrand = cloneBrandsList[index].brands.filter(current => current.name == BRAND_CODE_TOP_EXECUTIVE)[0];

			if (executiveBrand) {
				sortedBusinessBrands.push(executiveBrand);
			}
			if (topExecutiveBrand) {
				sortedBusinessBrands.push(topExecutiveBrand);
			}

			return sortedBusinessBrands;
		}

	}

	INDRA_getTax(brands) {
		if (brands.length != 0) {
			const lowest_points = brands.reduce(function (prev, curr) {
				return prev.bookAwardValue < curr.bookAwardValue ? prev : curr;
			});
			return `+ ${this.currencyService.INDRA_formatCash(lowest_points.tax)} ${this.currency}`;
		}
		return null;
	}

	INDRA_isLastSeat(brand) {
		if (brand.status != 'sold out' && !this.isOpen) {
			for (const i in brand.brands) {
				if (brand.brands[i].hasLastSeats && brand.brands[i].LastSeatFlightId.includes(this.flight.idFlight)) {
					// this.hasLastSeats = true;
					return true;
				}
			}
		}

		return false;
	}

	INDRA_getMessage(brand) {
		if (brand.slug == 'executive') {
			return this.flight.notAvailable ? 'notAvailable' : 'soldOut';
		}
		return 'soldOut';
	}


	// note: unused, but referenced in a commented out code in the template
	INDRA_changeFlight(): boolean {
		return this.router.url === '/my-bookings/change-flight/select-flight';
	}

	// note: unused, but referenced in a commented out code in the template
	INDRA_printSelectButtonLabel() {
		if (this.bookingService.isLastStep()) {
			if (this.timeToThink) {
				return 'Select flight and continue';
			}
			return 'Select flight and go to next page';
		} else {
			return 'Select next flight';
		}
	}

	// note: unused, but referenced in a commented out code in the template
	INDRA_handleTimeToThink() {
		if (this.isMobile) {
			return this.bookingService.allFlightsSelected();
		}
		return this.bookingService.isLastStep();
	}

	// note: unused, but referenced in a commented out code in the template
	INDRA_timeToThinkChanges() {
		this.timeToThink = !this.timeToThink;
	}

	// note: unused, but is referenced in a commented out code in the template
	INDRA_handlePriceBreakDown() {
		this.sidebarService.openSidebar(['price-breakdown']);
	}

	INDRA_formatEmbargoDate(date) {
		let dateArray = date.split(' ');
		if (date && dateArray.length > 5) {
			let embargoDate = dateArray[0] + ' ' + dateArray[1] + ' ' + dateArray[2] + ' ' + dateArray[3] + ' ' + dateArray[5];
			return this.dateService.INDRA_formatDate(embargoDate, 'MMMM Do YYYY');
		}
		return '';

	}

	INDRA_openUrl(key: string) {

		let lang = sessionStorage.getItem('language');
		let languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[lang] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[lang] : lang;
		let urlKey = this.ibeAdminConfigService.getConfigurationValue(key);
		urlKey = urlKey.replace('${dyanamicPartofURL}', this.INDRA_getTranslationKey('availability.flightsPage.text.extraBaggageCantBePurchasedLink'));

		if (lang && sessionStorage.getItem('market')) {
			urlKey = urlKey.replace('${lang}', languageMap);
			urlKey = urlKey.replace('${market}', sessionStorage.getItem('market'));
			return window.open(urlKey);
		}
	}

	INDRA_getTranslationKey(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes.activeOpenFlightId && changes.activeOpenFlightId.currentValue) {
      const activeOpenFlightId = changes.activeOpenFlightId.currentValue;
      if(this.flightInfo.flightId != activeOpenFlightId) {
        this.isOpen = false;
      }
    }
  }
}
